<div class="fade-in-left">
  <mat-form-field>
    <mat-label>{{ 'PORTAL.OPENING_HOURS.DAY_LABEL' | translate }}</mat-label>
    <mat-select [(ngModel)]="weekDay" [value]="null">
      @for (weekDay of weekDays; track weekDay) {
        <mat-option [value]="weekDay.dayOfWeek">{{ weekDay.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <table class="opening-hours">
    @if (weekDay() === null) {
      <tr>
        <td colspan="3">{{ 'PORTAL.OPENING_HOURS.SELECT_DAY' | translate }}</td>
      </tr>
    } @else {
      @for (modality of branchModalitiesByWeekDay(); track modality) {
        <tr>
          <td class="fade-in-left">
            <div class="modality-name">
              <mat-icon color="primary">{{ modality.icon }}</mat-icon>
              {{ modality.name }}
            </div>
          </td>
          <td>{{ modality.initialTime | slice: 0 : 5 }}</td>
          <td>{{ modality.endTime | slice: 0 : 5 }}</td>
        </tr>
      } @empty {
        <tr>
          <td colspan="3">{{ 'PORTAL.OPENING_HOURS.NO_SCHEDULE' | translate }}</td>
        </tr>
      }
    }
  </table>
  <div class="button-group">
    <button mat-stroked-button type="button" (click)="return.emit()">
      {{ 'PORTAL.OPENING_HOURS.RETURN' | translate }}
    </button>
  </div>
</div>
